import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../../contexts/LanguageContext';
import { translations } from '../../translations/translations';
import { ArrowRight } from 'lucide-react';
import './RegionSection.css';
import douro from '../../assets/RegiaoImage.jpg';
import { preloadRegionDetail } from '../../utils/routePreload';



export default function RegionSection() {
    const navigate = useNavigate();
    const { language } = useLanguage();
    const t = translations?.[language] || translations?.pt || {};
    const imgRef = useRef(null);
    const textRef = useRef(null);

    const handleExplore = () => {
        // Placeholder navigation, adjust as needed
        navigate('/region');
    };

    useEffect(() => {
        const nodes = [imgRef.current, textRef.current].filter(Boolean);
        const io = new IntersectionObserver(
            (entries) => entries.forEach(e => e.isIntersecting && e.target.classList.add('visible')),
            { threshold: 0.18 }
        );
        nodes.forEach(n => io.observe(n));
        return () => io.disconnect();
    }, []);

    return (
        <section className="region-section" id="a-regiao-section">
            <div className="region-container">
                <h3 className="subtitulo">{t.region.subtitle}</h3>
                <div className="region-item">
                    <div className="region-image-wrap">
                        <img ref={imgRef} className="region-image" src={douro} alt="Rio Douro" loading="lazy" />
                    </div>

                    <div className="region-text" ref={textRef}>
                        <h3 className="subtitulo">{t.region.subtitle}</h3>
                        <h2 className="titulo">{t.region.title}</h2>
                        <p className="lead">
                            {t.region.lead}
                        </p>
                        <p className="body">
                            {t.region.body}


                        </p>
                        <button
                            className="region-explore-btn"
                            onClick={handleExplore}
                            onMouseEnter={preloadRegionDetail}
                            onFocus={preloadRegionDetail}
                        >
                            <span>{t.region.exploreBtn}</span>
                            <div className="btn-circle">
                                <ArrowRight size={18} strokeWidth={1.5} />
                            </div>
                        </button>
                    </div>
                </div>
            </div>
        </section>
    );
}
